import React, { useState } from 'react';
import { ORG_SAVE_ENDPOINT, ORG_DUPLICATE_CHECK_ENDPOINT } from '../../config/api';
import { encryptData, decryptData } from '../../utils/encrypt';
import Navbar from '../layout/Navbar';

function OrganizationForm() {
  const encrypted = localStorage.getItem('suyog_user');
  const user = encrypted ? decryptData(encrypted) : { user_id: 0 };
  const [duplicateName, setDuplicateName] = useState(false);

  const [form, setForm] = useState({
    org_name: '',
    address: '',
    city: '',
    pan_number: '',
    gst_number: '',
    pincode: '',
  });

  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const checkDuplicateName = async () => {
    if (!form.org_name.trim()) return;

    try {
      const res = await fetch(ORG_DUPLICATE_CHECK_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ org_name: form.org_name.trim() }),
      });

      const data = await res.json();
      setDuplicateName(data.exists || false);
    } catch (err) {
      console.error('Duplicate check failed:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    const payload = {
      ...form,
      created_by: user.user_id, // ✅ Send raw user_id
      user_token: user.user_token
    };

    try {
      const res = await fetch(ORG_SAVE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok && data.message) {
        setMessage({ type: 'success', text: data.message });
        setForm({
          org_name: '',
          address: '',
          city: '',
          pan_number: '',
          gst_number: '',
          pincode: '',
        });
        setDuplicateName(false);
      } else {
        setMessage({ type: 'error', text: data.error || '❌ Save failed' });
      }
    } catch (error) {
      console.error(error);
      setMessage({ type: 'error', text: '❌ Server error' });
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="card shadow p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0"><i className="bi bi-building"></i> Organization Master</h4>
          </div>

          {message && (
            <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'} d-flex align-items-center`}>
              <i className={`bi ${message.type === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'} me-2`}></i>
              {message.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Organization Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  name="org_name"
                  value={form.org_name}
                  onChange={handleChange}
                  onBlur={checkDuplicateName}
                  className={`form-control ${duplicateName ? 'is-invalid' : ''}`}
                  required
                />
                {duplicateName && <div className="invalid-feedback">Organization name already exists.</div>}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">Address</label>
                <textarea name="address" value={form.address} onChange={handleChange} className="form-control" rows="2" />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">City <span className="text-danger">*</span></label>
                <input type="text" name="city" value={form.city} onChange={handleChange} className="form-control" required />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Pincode <span className="text-danger">*</span></label>
                <input type="text" name="pincode" value={form.pincode} onChange={handleChange} className="form-control" required />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">PAN Number</label>
                <input type="text" name="pan_number" value={form.pan_number} onChange={handleChange} className="form-control" />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">GST Number</label>
                <input type="text" name="gst_number" value={form.gst_number} onChange={handleChange} className="form-control" />
              </div>
            </div>

            <div className="text-end d-flex justify-content-between mt-3">
              <button type="submit" className="btn btn-success" disabled={duplicateName}>
                <i className="bi bi-save me-2"></i>Save Organization
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default OrganizationForm;
